module.exports = __webpack_public_path__ + "img/logoNinhBinh.161150c7.jpg";